<template>
  <div class="main-wrapper">
    <p>
      Сведения о планируемых операциях по счету/счетам в {{ bankName }}
      <span class="bold-text">за квартал</span>
    </p>
    <div class="main-in-trade">
      <p class="bold-text">
        <span
          :class="
            this.validateArray(mainInTrade.count)
              ? 'valid-field'
              : 'unvalid-field'
          "
          >➤</span
        >
        Количество операций по поступлению:
      </p>
      <div class="checkboxes">
        <label v-for="item in operationCountValues" :key="item.id"
          ><input
            type="checkbox"
            v-model="mainInTrade.count"
            :value="item.id"
            @click="mainInTrade.count = [item.id]"
            :disabled="
              pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('PLAN_OPERATIONS_DT_COUNT') != -1
            "
          />{{ item.value }}</label
        >
      </div>
      <p class="bold-text">
        <span
          :class="
            this.validateArray(mainInTrade.money)
              ? 'valid-field'
              : 'unvalid-field'
          "
          >➤</span
        >
        Сумма операций по поступлению:
      </p>
      <div class="checkboxes">
        <label v-for="item in operationAmountValues" :key="item.id"
          ><input
            type="checkbox"
            v-model="mainInTrade.money"
            :value="item.id"
            @click="
              mainInTrade.money = [item.id];
              checkOtherValues();
            "
            :disabled="
              pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('PLAN_OPERATIONS_DB_AMOUNT') != -1
            "
          />{{ item.value }}</label
        >
      </div>
    </div>
    <div class="main-out-trade">
      <p class="bold-text">
        <span
          :class="
            this.validateArray(mainOutTrade.count)
              ? 'valid-field'
              : 'unvalid-field'
          "
          >➤</span
        >
        Количество операций по списанию:
      </p>
      <div class="checkboxes">
        <label v-for="item in operationCountValues" :key="item.id"
          ><input
            type="checkbox"
            v-model="mainOutTrade.count"
            :value="item.id"
            @click="mainOutTrade.count = [item.id]"
            :disabled="
              pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('PLAN_OPERATIONS_CR_COUNT') != -1
            "
          />{{ item.value }}</label
        >
      </div>
      <p class="bold-text">
        <span
          :class="
            this.validateArray(mainOutTrade.money) && !this.unvalidMainOutMoreIn
              ? 'valid-field'
              : 'unvalid-field'
          "
          >➤</span
        >
        Сумма операций по списанию:
      </p>
      <div class="checkboxes">
        <label v-for="item in operationAmountValues" :key="item.id"
          ><input
            type="checkbox"
            v-model="mainOutTrade.money"
            :value="item.id"
            @click="
              mainOutTrade.money = [item.id];
              checkMainOutTrade();
            "
            :disabled="
              pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('PLAN_OPERATIONS_CR_AMOUNT') != -1
            "
          />{{ item.value }}</label
        >
      </div>
    </div>
    <p>
      <span
        :class="
          (outTradeDeal[0] || outTradeDeal[1]) && validateAllOutTradeNoPlan()
            ? 'valid-field'
            : 'unvalid-field'
        "
        >➤</span
      >
      В том числе планируются операции, связанные с переводами денежных средств
      в рамках внешнеторговой деятельности
      <span class="bold-text">за квартал</span>
    </p>
    <div class="checkboxes-row">
      <label>
        <input
          type="checkbox"
          v-model="outTradeDeal[0]"
          @click="
            isUpdated = true;
            outTradeDeal = [outTradeDeal[0], false];
            unvalidAbroadInMoreIn = false;
            unvalidAbroadOutMoreOut = false;
            outTrade.money = [];
            outTrade.count = [];
            outTradeDealOut.money = [];
            outTradeDealOut.count = [];
          "
          :disabled="
            (pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('PLAN_OPER_DB_COUNT_VTRG') != -1) ||
            (pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('PLAN_OPER_DB_AMOUNT_VTRG') != -1) ||
            (pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('PLAN_OPER_CR_COUNT_VTRG')) ||
            (pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('PLAN_OPER_CR_AMOUNT_VTRG'))
          "
        />ДА
      </label>
      <label>
        <input
          type="checkbox"
          v-model="outTradeDeal[1]"
          @click="
            isUpdated = true;
            outTradeDeal = [false, outTradeDeal[1]];
            unvalidAbroadInMoreIn = false;
            unvalidAbroadOutMoreOut = false;
            outTrade.money = [];
            outTrade.count = [];
            outTradeDealOut.money = [];
            outTradeDealOut.count = [];
          "
          :disabled="
            (pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('PLAN_OPER_DB_COUNT_VTRG') != -1) ||
            (pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('PLAN_OPER_DB_AMOUNT_VTRG') != -1) ||
            (pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('PLAN_OPER_CR_COUNT_VTRG')) ||
            (pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('PLAN_OPER_CR_AMOUNT_VTRG'))
          "
        />НЕТ
      </label>
    </div>
    <div class="out-trade" v-if="outTradeDeal[0]">
      <div class="out-trade">
        <p class="bold-text">
          <span
            :class="
              this.validateOutTradeCount() ? 'valid-field' : 'unvalid-field'
            "
            >➤</span
          >
          Количество операций по поступлению:
        </p>
        <div class="checkboxes">
          <label v-for="item in operationCountValuesNoPlan" :key="item.id"
            ><input
              type="checkbox"
              v-model="outTrade.count"
              :value="item.id"
              @click="outTrade.count = [item.id]"
              :disabled="
                pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('PLAN_OPER_DB_COUNT_VTRG') != -1
              "
            />{{ item.value }}</label
          >
        </div>
        <p class="bold-text">
          <span
            :class="
              this.validateOutTradeMoney() && !this.unvalidAbroadInMoreIn
                ? 'valid-field'
                : 'unvalid-field'
            "
            >➤</span
          >
          Сумма операций по поступлению:
        </p>
        <div class="checkboxes">
          <label v-for="item in operationAmountValuesNoPlan" :key="item.id"
            ><input
              type="checkbox"
              v-model="outTrade.money"
              :value="item.id"
              @click="
                outTrade.money = [item.id];
                checkOutTradeIn();
              "
              :disabled="
                pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('PLAN_OPER_DB_AMOUNT_VTRG') != -1
              "
            />{{ item.value }}</label
          >
        </div>
      </div>
      <div class="out-trade-deal-out">
        <p class="bold-text">
          <span
            :class="
              this.validateOutTradeOutCount() ? 'valid-field' : 'unvalid-field'
            "
            >➤</span
          >
          Количество операций по списанию:
        </p>
        <div class="checkboxes">
          <label v-for="item in operationCountValuesNoPlan" :key="item.id"
            ><input
              type="checkbox"
              v-model="outTradeDealOut.count"
              :value="item.id"
              @click="outTradeDealOut.count = [item.id]"
              :disabled="
                pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('PLAN_OPER_CR_COUNT_VTRG') != -1
              "
            />{{ item.value }}</label
          >
        </div>
        <p class="bold-text">
          <span
            :class="
              this.validateOutTradeOutMoney() && !this.unvalidAbroadOutMoreOut
                ? 'valid-field'
                : 'unvalid-field'
            "
            >➤</span
          >
          Сумма операций по списанию:
        </p>
        <div class="checkboxes">
          <label v-for="item in operationAmountValuesNoPlan" :key="item.id"
            ><input
              type="checkbox"
              v-model="outTradeDealOut.money"
              :value="item.id"
              @click="
                outTradeDealOut.money = [item.id];
                checkOutTradeOut();
              "
              :disabled="
                pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('PLAN_OPER_CR_AMOUNT_VTRG') != -1
              "
            />{{ item.value }}</label
          >
        </div>
      </div>
    </div>
    <p>
      <span :class="nalDeal[0] || nalDeal[1] ? 'valid-field' : 'unvalid-field'"
        >➤</span
      >
      Планируются операции по снятию денежных средств в наличной форме
      (например: заработная плата, выплаты социального характера, займы, на
      оплату по договорам) <span class="bold-text">за квартал</span>
    </p>
    <div class="checkboxes-row">
      <label>
        <input
          type="checkbox"
          v-model="nalDeal[0]"
          @click="
            isUpdated = true;
            nalDeal = [nalDeal[0], false];
            nalTrade.money = [];
            nalTrade.count = [];
          "
          :disabled="
            (pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('PLAN_OPERATIONS_CSH_COUNT') != -1) ||
            (pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('PLAN_OPERATIONS_CSH_AMOUNT') != -1)
          "
        />ДА
      </label>
      <label>
        <input
          type="checkbox"
          v-model="nalDeal[1]"
          @click="
            isUpdated = true;
            nalDeal = [false, nalDeal[1]];
            nalTrade.money = [];
            nalTrade.count = [];
          "
          :disabled="
            (pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('PLAN_OPERATIONS_CSH_COUNT') != -1) ||
            (pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('PLAN_OPERATIONS_CSH_AMOUNT') != -1)
          "
        />НЕТ
      </label>
    </div>
    <div class="nal-trade" v-if="nalDeal[0]">
      <p class="bold-text">
        <span
          :class="
            this.validateArray(nalTrade.count) ? 'valid-field' : 'unvalid-field'
          "
          >➤</span
        >
        Количество операций:
      </p>
      <div class="checkboxes">
        <label v-for="item in operationCountValuesSmall" :key="item.id"
          ><input
            type="checkbox"
            v-model="nalTrade.count"
            :value="item.id"
            @click="nalTrade.count = [item.id]"
            :disabled="
              pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('PLAN_OPERATIONS_CSH_COUNT') != -1
            "
          />{{ item.value }}</label
        >
      </div>
      <p class="bold-text">
        <span
          :class="
            this.validateArray(nalTrade.money) ? 'valid-field' : 'unvalid-field'
          "
          >➤</span
        >
        Сумма операций:
      </p>
      <div class="checkboxes">
        <label v-for="item in operationAmountValuesSmall" :key="item.id"
          ><input
            type="checkbox"
            v-model="nalTrade.money"
            :value="item.id"
            @click="nalTrade.money = [item.id]"
            :disabled="
              pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('PLAN_OPERATIONS_CSH_AMOUNT') != -1
            "
          />{{ item.value }}</label
        >
      </div>
    </div>
    <p>
      <span
        :class="budgetRF[0] || budgetRF[1] ? 'valid-field' : 'unvalid-field'"
        >➤</span
      >
      Планируются операции, связанные с налоговыми и другими обязательными
      платежами в бюджетную систему РФ <span class="bold-text">за квартал</span>
    </p>
    <div class="checkboxes-row">
      <label>
        <input
          type="checkbox"
          v-model="budgetRF[0]"
          @click="
            isUpdated = true;
            budgetRF = [budgetRF[0], false];
            countRF = [];
            updateOtherBank();
          "
          :disabled="
            pageInfo.DISABLED != null &&
            pageInfo.DISABLED.indexOf('PLAN_OPER_BUDGET_AMT') != -1
          "
        />ДА
      </label>
      <label>
        <input
          type="checkbox"
          v-model="budgetRF[1]"
          @click="
            isUpdated = true;
            budgetRF = [false, budgetRF[1]];
            countRF = [];
            updateOtherBank();
          "
          :disabled="
            pageInfo.DISABLED != null &&
            pageInfo.DISABLED.indexOf('PLAN_OPER_BUDGET_AMT') != -1
          "
        />НЕТ
      </label>
    </div>
    <p class="necessary-table-not" v-if="budgetRF[1] && !validateBanks()">
      Заполните хотя бы одну строку таблицы.
    </p>
    <table v-if="budgetRF[1]">
      <tr>
        <td width="2%"></td>
        <td class="left-column">
          <p class="necessary-bold">БИК банка, <br />СВИФТ банка-нерезидента</p>
        </td>
        <td class="necessary-bold">Наименование</td>
      </tr>
      <tr v-for="bank in otherBanks" :key="bank.id">
        <td>
          <span :class="validateBank(bank) ? 'valid-field' : 'unvalid-field'"
            >➤</span
          >
        </td>
        <td>
          <input
            type="text"
            class="input-line"
            v-model="bank.BIK"
            v-mask="'###########'"
            @blur="controlBanks(bank)"
            @focus="isUpdated = true"
          />
        </td>
        <td>
          <input
            class="input-line"
            type="text"
            v-model="bank.name"
            :disabled="bank.gettingInfo"
          />
        </td>
      </tr>
    </table>

    <div class="budget-RF" v-if="budgetRF[0]">
      <p class="bold-text">
        <span
          :class="
            this.validateArray(countRF) && !this.unvalidTax
              ? 'valid-field'
              : 'unvalid-field'
          "
          >➤</span
        >
        Сумма операций:
      </p>
      <div class="checkboxes">
        <label v-for="item in operationAmountValuesSmall" :key="item.id"
          ><input
            type="checkbox"
            v-model="countRF"
            :value="item.id"
            @click="
              countRF = [item.id];
              checkTax();
            "
            :disabled="
              pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('PLAN_OPER_BUDGET_AMT') != -1
            "
          />{{ item.value }}</label
        >
      </div>
    </div>
  </div>
</template>

<script>
import { VMoney } from "v-money";

export default {
  name: "PlanOperations",
  props: {
    pageInfo: {},
    pageName: String,
    bankName: String,
    url: String,
  },
  directives: { money: VMoney },
  data: () => ({
    outTradeDeal: [false, false],
    nalDeal: [false, false],
    budgetRF: [false, false],
    unvalidMainOutMoreIn: false,
    unvalidAbroadInMoreIn: false,
    unvalidAbroadOutMoreOut: false,
    unvalidTax: false,
    isUpdated: false,
    sendData: {},
    countRF: [],
    operationCountValues: [
      { id: 0, value: "до 50" },
      { id: 1, value: "от 50 до 100" },
      { id: 2, value: "от 100 до 500" },
      { id: 3, value: "свыше 500" },
    ],
    operationAmountValues: [
      { id: 0, value: "до 1 млн. рублей" },
      { id: 1, value: "от 1 до 5 млн. рублей" },
      { id: 2, value: "от 5 до 10 млн. рублей" },
      { id: 3, value: "от 10 до 30 млн. рублей" },
      { id: 4, value: "от 30 до 100 млн. рублей" },
      { id: 5, value: "свыше 100 млн. рублей" },
    ],
    operationCountValuesNoPlan: [
      { id: 0, value: "не планируются" },
      { id: 1, value: "до 50" },
      { id: 2, value: "от 50 до 100" },
      { id: 3, value: "от 100 до 500" },
      { id: 4, value: "свыше 500" },
    ],
    operationAmountValuesNoPlan: [
      { id: 0, value: "не планируются" },
      { id: 1, value: "до 1 млн. рублей" },
      { id: 2, value: "от 1 до 5 млн. рублей" },
      { id: 3, value: "от 5 до 10 млн. рублей" },
      { id: 4, value: "от 10 до 30 млн. рублей" },
      { id: 5, value: "от 30 до 100 млн. рублей" },
      { id: 6, value: "свыше 100 млн. рублей" },
    ],
    operationCountValuesSmall: [
      { id: 0, value: "до 10" },
      { id: 1, value: "от 10 до 50" },
      { id: 2, value: "от 50 до 100" },
      { id: 3, value: "свыше 100" },
    ],
    operationAmountValuesSmall: [
      { id: 0, value: "до 500 тыс. рублей" },
      { id: 1, value: "от 500 тыс. рублей до 1 млн. рублей" },
      { id: 2, value: "от 1 до 3 млн. рублей" },
      { id: 3, value: "от 3 до 5 млн. рублей" },
      { id: 4, value: "свыше 5 млн. рублей" },
    ],
    otherBanks: [],
    outTradeDealOut: {
      money: [],
      count: [],
    },
    outTrade: {
      money: [],
      count: [],
    },
    mainInTrade: {
      money: [],
      count: [],
    },
    mainOutTrade: {
      money: [],
      count: [],
    },
    nalTrade: {
      money: [],
      count: [],
    },
    money: {
      decimal: ",",
      thousands: " ",
      prefix: "",
      suffix: "",
      precision: 0,
      masked: false,
    },
  }),
  methods: {
    getSubstr(text) {
      return text.substr(0, 12);
    },
    checkMainOutTrade() {
      if (
        this.validateArray(this.mainInTrade.money) &&
        this.validateArray(this.mainOutTrade.money)
      ) {
        this.unvalidMainOutMoreIn =
          this.getArrayFirst(this.mainInTrade.money) <
          this.getArrayFirst(this.mainOutTrade.money);
        this.checkOutTradeOut();
      } else this.unvalidMainOutMoreIn = false;
    },
    checkOtherValues() {
      this.checkMainOutTrade();
      this.checkOutTradeIn();
      this.checkTax();
    },
    checkOutTradeIn() {
      if (
        this.validateArray(this.mainInTrade.money) &&
        this.validateArray(this.outTrade.money)
      ) {
        this.unvalidAbroadInMoreIn =
          this.getArrayFirst(this.mainInTrade.money) <
          this.getArrayFirst(this.outTrade.money) - 1;
      } else this.unvalidAbroadInMoreIn = false;
    },
    checkOutTradeOut() {
      if (
        this.validateArray(this.mainOutTrade.money) &&
        this.validateArray(this.outTradeDealOut.money)
      ) {
        this.unvalidAbroadOutMoreOut =
          this.getArrayFirst(this.mainOutTrade.money) <
          this.getArrayFirst(this.outTradeDealOut.money) - 1;
      } else this.unvalidAbroadOutMoreOut = false;
    },
    checkTax() {
      if (
        this.validateArray(this.mainInTrade.money) &&
        this.validateArray(this.countRF)
      ) {
        this.unvalidTax =
          this.getArrayFirst(this.mainInTrade.money) * 2 + 1 <
          this.getArrayFirst(this.countRF);
      } else this.unvalidTax = false;
    },
    validateArray(arr) {
      return this.getArrayFirst(arr) != -1;
    },
    validateOutTradeMoney() {
      return (
        this.validateArray(this.outTrade.money) &&
        ((this.getArrayFirst(this.outTrade.count) == 0 &&
          this.getArrayFirst(this.outTrade.money) == 0) ||
          (this.getArrayFirst(this.outTrade.count) != 0 &&
            this.getArrayFirst(this.outTrade.money) != 0))
      );
    },
    validateOutTradeCount() {
      return (
        this.validateArray(this.outTrade.count) &&
        ((this.getArrayFirst(this.outTrade.count) == 0 &&
          this.getArrayFirst(this.outTrade.money) == 0) ||
          (this.getArrayFirst(this.outTrade.count) != 0 &&
            this.getArrayFirst(this.outTrade.money) != 0))
      );
    },
    validateOutTradeOutMoney() {
      return (
        this.validateArray(this.outTradeDealOut.money) &&
        ((this.getArrayFirst(this.outTradeDealOut.count) == 0 &&
          this.getArrayFirst(this.outTradeDealOut.money) == 0) ||
          (this.getArrayFirst(this.outTradeDealOut.count) != 0 &&
            this.getArrayFirst(this.outTradeDealOut.money) != 0))
      );
    },
    validateOutTradeOutCount() {
      return (
        this.validateArray(this.outTradeDealOut.count) &&
        ((this.getArrayFirst(this.outTradeDealOut.count) == 0 &&
          this.getArrayFirst(this.outTradeDealOut.money) == 0) ||
          (this.getArrayFirst(this.outTradeDealOut.count) != 0 &&
            this.getArrayFirst(this.outTradeDealOut.money) != 0))
      );
    },
    validateAllOutTradeNoPlan() {
      return !(
        this.getArrayFirst(this.outTradeDealOut.count) == 0 &&
        this.getArrayFirst(this.outTradeDealOut.money) == 0 &&
        this.getArrayFirst(this.outTrade.count) == 0 &&
        this.getArrayFirst(this.outTrade.money) == 0
      );
    },
    validation() {
      var msg = "";
      if (this.budgetRF[1] && !this.validateBanks())
        msg += "• Корректно введите хотя бы один банк;<br>";
      if (this.unvalidMainOutMoreIn)
        msg +=
          "• Сумма общего списания не может быть больше суммы общего поступления;<br>";
      if (this.unvalidAbroadInMoreIn)
        msg +=
          "• Сумма внешнеторгового поступления не может быть больше суммы общего поступления;<br>";
      if (this.unvalidAbroadOutMoreOut)
        msg +=
          "• Сумма внешнеторгового списания не может быть больше суммы общего списания;<br>";
      if (this.unvalidTax)
        msg +=
          "• Сумма налогового списания не может быть больше суммы общего поступления;<br>";
      if (!this.validateArray(this.mainInTrade.count))
        msg +=
          "Необходимо заполнить поля:<br>• Общее поступление, количество операций;<br>";
      if (!this.validateArray(this.mainInTrade.money))
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Общее поступление, сумма операций;<br>"
            : "• Общее поступление, сумма операций;<br>";
      if (!this.validateArray(this.mainOutTrade.count))
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Общее списание, количество операций;<br>"
            : "• Общее списание, количество операций;<br>";
      if (!this.validateArray(this.mainOutTrade.money))
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Общее списание, сумма операций;<br>"
            : "• Общее списание, сумма операций;<br>";
      if (!(this.outTradeDeal[0] || this.outTradeDeal[1]))
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Наличие операций, связанных с внешнеторговой деятельностью;<br>"
            : "• Наличие операций, связанных с внешнеторговой деятельностью;<br>";
      if (this.outTradeDeal[0] && !this.validateOutTradeCount())
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Внешнеторговое поступление, количество операций;<br>"
            : "• Внешнеторговое поступление, количество операций;<br>";
      if (this.outTradeDeal[0] && !this.validateOutTradeMoney())
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Внешнеторговое поступление, сумма операций;<br>"
            : "• Внешнеторговое поступление, сумма операций;<br>";
      if (this.outTradeDeal[0] && !this.validateOutTradeOutCount())
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Внешнеторговое списание, количество операций;<br>"
            : "• Внешнеторговое списание, количество операций;<br>";
      if (this.outTradeDeal[0] && !this.validateOutTradeOutMoney())
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Внешнеторговое списание, сумма операций;<br>"
            : "• Внешнеторговое списание, сумма операций;<br>";
      if (!this.validateAllOutTradeNoPlan())
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Подтвердите отсутствие внешнеторговых операций;<br>"
            : "• Подтвердите отсутствие внешнеторговых операций;<br>";
      if (!(this.nalDeal[0] || this.nalDeal[1]))
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Наличие операций операции по снятию денежных средств в наличной форме;<br>"
            : "• Наличие операций по снятию денежных средств в наличной форме;<br>";
      if (this.nalDeal[0] && !this.validateArray(this.nalTrade.count))
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Снятие в наличной форме, количество операций;<br>"
            : "• Снятие в наличной форме, количество операций;<br>";
      if (this.nalDeal[0] && !this.validateArray(this.nalTrade.money))
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Снятие в наличной форме, сумма операций;<br>"
            : "• Снятие в наличной форме, сумма операций;<br>";
      if (!(this.budgetRF[0] || this.budgetRF[1]))
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Наличие операций операции, связанных с налоговыми и другими обязательными платежами;<br>"
            : "• Наличие операций, связанных с налоговыми и другими обязательными платежами;<br>";
      if (this.budgetRF[0] && !this.validateArray(this.countRF))
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Налоговые платежи, сумма операций;<br>"
            : "• Налоговые платежи, сумма операций;<br>";
      this.$emit("enableButtons", true, msg);
      this.getCompleteSendData();
      this.$emit("changePageSendData", this.sendData, false);
      if (msg.length == 0) {
        this.getCompleteSendData();
        this.$emit("changePageSendData", this.sendData, false);
      }
    },
    validateBank(bank) {
      return (
        bank.BIK.length >= 8 && bank.BIK.length <= 11 && bank.name.length > 0
      );
    },
    validateBanks() {
      let bankIsOk = false;
      this.otherBanks.forEach((item) => {
        bankIsOk = bankIsOk || this.validateBank(item);
      });
      return bankIsOk;
    },
    controlBanks(bank) {
      if (bank.BIK.length < 8) bank.name = "";
      if (bank.BIK.length >= 8 && bank.BIK.length <= 11) {
        this.getBankName(bank);
        if (this.otherBanks[this.otherBanks.length - 1].BIK.length > 0) {
          this.otherBanks.push({
            id: this.otherBanks.length + 1,
            BIK: "",
            name: "",
          });
          this.otherBanks[this.otherBanks.length - 1].id =
            this.otherBanks.length;
        }
      }
    },
    updateOtherBank() {
      this.otherBanks = [
        {
          id: this.otherBanks.length + 1,
          BIK: "",
          name: "",
          gettingInfo: false,
        },
      ];
    },
    fillFields() {
      if (this.pageInfo.PLAN_OPERATIONS_DT_COUNT != null)
        this.mainInTrade.count = [this.pageInfo.PLAN_OPERATIONS_DT_COUNT];
      if (this.pageInfo.PLAN_OPERATIONS_DB_AMOUNT != null)
        this.mainInTrade.money = [this.pageInfo.PLAN_OPERATIONS_DB_AMOUNT];
      if (this.pageInfo.PLAN_OPERATIONS_CR_COUNT != null)
        this.mainOutTrade.count = [this.pageInfo.PLAN_OPERATIONS_CR_COUNT];
      if (this.pageInfo.PLAN_OPERATIONS_CR_AMOUNT != null)
        this.mainOutTrade.money = [this.pageInfo.PLAN_OPERATIONS_CR_AMOUNT];
      if (
        this.pageInfo.PLAN_OPERATIONS_CSH_COUNT != null &&
        this.pageInfo.PLAN_OPERATIONS_CSH_AMOUNT != null
      ) {
        if (this.pageInfo.PLAN_OPERATIONS_CSH_COUNT != -1) {
          this.nalTrade.count = [this.pageInfo.PLAN_OPERATIONS_CSH_COUNT];
          this.nalTrade.money = [this.pageInfo.PLAN_OPERATIONS_CSH_AMOUNT];
          this.nalDeal = [true, false];
        } else {
          this.nalDeal = [false, true];
        }
      }
      if (
        this.pageInfo.PLAN_OPER_DB_AMOUNT_VTRG != null &&
        this.pageInfo.PLAN_OPER_DB_COUNT_VTRG != null &&
        this.pageInfo.PLAN_OPER_CR_COUNT_VTRG != null &&
        this.pageInfo.PLAN_OPER_CR_AMOUNT_VTRG != null
      ) {
        if (this.pageInfo.PLAN_OPER_DB_AMOUNT_VTRG != -1) {
          this.outTrade.money = [this.pageInfo.PLAN_OPER_DB_AMOUNT_VTRG];
          this.outTrade.count = [this.pageInfo.PLAN_OPER_DB_COUNT_VTRG];
          this.outTradeDealOut.count = [this.pageInfo.PLAN_OPER_CR_COUNT_VTRG];
          this.outTradeDealOut.money = [this.pageInfo.PLAN_OPER_CR_AMOUNT_VTRG];
          this.outTradeDeal = [true, false];
        } else {
          this.outTradeDeal = [false, true];
        }
      }
      if (this.pageInfo.PLAN_OPER_BUDGET_AMT != null) {
        if (this.pageInfo.PLAN_OPER_BUDGET_AMT != -1) {
          this.countRF = [this.pageInfo.PLAN_OPER_BUDGET_AMT];
          this.budgetRF = [true, false];
        } else this.budgetRF = [false, true];
      }
    },
    async getBankName(bank) {
      bank.gettingInfo = true;
      try {
        let data = await (
          await fetch(this.url + "get_bank_by_bik", {
            method: "POST",
            headers: {
              "Content-Type": "application/json;charset=utf-8",
            },
            body: JSON.stringify({ INN: this.pageInfo.INN, BIK: bank.BIK }),
          })
        ).json();
        if (data.BIK != null) bank.name = data.BIK;
      } catch (e) {
        console.log(e);
      }
      bank.gettingInfo = false;
      this.validation();
    },
    fillBanks() {
      this.pageInfo.PREV_BANKS.forEach((item) => {
        this.budgetRF = [false, true];
        this.otherBanks.push({
          id: this.otherBanks.length + 1,
          BIK: item.PREV_BANK_BIK,
          name: item.PREV_BANK_NAME,
          gettingInfo: false,
        });
      });
      this.otherBanks.push({
        id: this.otherBanks.length + 1,
        BIK: "",
        name: "",
        gettingInfo: false,
      });
    },
    pushBanks() {
      this.sendData.PREV_BANKS = [];
      this.otherBanks.forEach((item) => {
        if (item.BIK.length >= 8 && item.name.length > 0) {
          let a = {};
          a.PREV_BANK_BIK = item.BIK;
          a.PREV_BANK_NAME = item.name;
          this.sendData.PREV_BANKS.push(a);
        }
      });
    },
    getArrayFirst(arr) {
      if (arr.length > 0) return arr[0];
      else return -1;
    },
    getCompleteSendData() {
      this.sendData.PLAN_OPERATIONS_DT_COUNT = this.getArrayFirst(
        this.mainInTrade.count
      );
      this.sendData.PLAN_OPERATIONS_DB_AMOUNT = this.getArrayFirst(
        this.mainInTrade.money
      );
      this.sendData.PLAN_OPERATIONS_CR_AMOUNT = this.getArrayFirst(
        this.mainOutTrade.money
      );
      this.sendData.PLAN_OPERATIONS_CR_COUNT = this.getArrayFirst(
        this.mainOutTrade.count
      );
      this.sendData.PLAN_OPERATIONS_CSH_AMOUNT = this.getArrayFirst(
        this.nalTrade.money
      );
      this.sendData.PLAN_OPERATIONS_CSH_COUNT = this.getArrayFirst(
        this.nalTrade.count
      );
      this.sendData.PLAN_OPER_DB_COUNT_VTRG = this.getArrayFirst(
        this.outTrade.count
      );
      this.sendData.PLAN_OPER_DB_AMOUNT_VTRG = this.getArrayFirst(
        this.outTrade.money
      );
      this.sendData.PLAN_OPER_CR_COUNT_VTRG = this.getArrayFirst(
        this.outTradeDealOut.count
      );
      this.sendData.PLAN_OPER_CR_AMOUNT_VTRG = this.getArrayFirst(
        this.outTradeDealOut.money
      );
      this.sendData.PLAN_OPER_BUDGET_AMT = this.getArrayFirst(this.countRF);
      this.pushBanks();
    },
  },
  async created() {
    this.fillFields();
    this.fillBanks();
    this.sendData.INN = this.pageInfo.INN;
    this.sendData.UPDATE_DATE = this.pageInfo.UPDATE_DATE;
    this.sendData.ID = this.pageInfo.ID;
    this.validation();
  },
  updated() {
    this.validation();
    if (this.isUpdated) this.$emit("updated");
  },
};
</script>

<style scoped>
.main-wrapper {
  text-align: justify;
}
td {
  padding: 5px;
}
label {
  padding-right: 10px;
}
input[type="text"]:focus {
  border-bottom: 1px solid #06569b;
  outline: none;
}
.input-line {
  border: none;
  border-bottom: 1px solid #cccccc;
  width: 100%;
  position: relative;
}
.input-line:focus,
.necessary-valid:focus,
.necessary-unvalid:focus {
  border-bottom: 1px solid #06569b;
  outline: none;
}
table {
  border: 1px solid #cccccc;
  margin: 10px 5px;
  text-align: left;
  width: 75%;
}
.necessary {
  color: red;
}
.necessary-message {
  color: red;
  font-size: 12px;
}
.necessary-unvalid {
  border: none;
  border-bottom: 1px solid red;
  width: 100%;
}
.necessary-valid {
  border: none;
  width: 100%;
  border-bottom: 1px solid #cccccc;
}
.left-column {
  width: 30%;
}
</style>
